import moment, {Moment} from 'moment'

export const getMoment = (date: string) => {
  return moment(date, 'YYYY-MM-DD HH:mm:ss')
}

export const formatMoment = (moment: Moment) => {
  return moment.format('hh:mm A')
}
